import(/* webpackMode: "eager" */ "/builds/jetspeak/jetclass-web/govoriru/app/global-error.tsx");
